<template>
  <div class="vh-100 loading-bg overflow-hidden">
    <Vue3Lottie
      class="mt-5"
      :animationData="lottieAnimation"
      :height="300"
      :width="350"
      :loop="true"
      :speed="1"
      :autoPlay="true"
      direction="forward"
    />
    <div style="width: 100%; text-align: center" class="px-3 mt-3">
      <span
        style="
          color: #2c7040;
          font-size: 24px;
          font-family: Nunito;
          font-weight: 700;
          line-height: 32px;
          word-wrap: break-word;
        "
        >{{ t("SHARED.CL_REGISTER_LOADER_TITLE") }}<br />
        <br /></span
      ><span
        style="
          color: black;
          font-size: 15px;
          font-family: Nunito;
          font-weight: 400;
          line-height: 25px;
          word-wrap: break-word;
        "
        >{{ t("SHARED.CL_REGISTER_LOADER_DISCLAIMER") }}</span
      >
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Vue3Lottie } from "vue3-lottie";
import lottieAnimation from "@/assets/lottie-animations/loading_your_cl.json";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "LoadingOffer",
  components: { Vue3Lottie },
  props: {
    title: String,
    disclaimer: String,
  },
  setup() {
    const { t } = useI18n();

    return { t, lottieAnimation };
  },
});
</script>

<style lang="scss" scoped>
.loading-bg {
  background: #fff;
}
</style>
